import { FC } from 'react';

import { MessageMedium } from 'modules/graphql/types';
import { ExpandModes } from 'utils/contexts/expansion';
import { NBAReengagementModal } from 'modules/ai/nba/components/NBAReengagementModal';
import { useNBAContext } from 'modules/ai/nba/context/NBAContext';
import { NewTabLink } from 'ui/links';
import { createPromptSubHeader } from 'modules/ai/nba/utils/medium';
import { CampaignNBACardHeader } from './CampaignNBACardHeader';
import { CampaignNBACardContent } from './CampaignNBACardContent';
import { StyledCampaignAnalyticsCard, StyledDivider, StyledLearnMoreLinkWrapper } from '../Styled';

export interface CampaignNBAProps {
  messageMedium: MessageMedium;
  title?: string;
}
export const CampaignNBACard: FC<React.PropsWithChildren<CampaignNBAProps>> = ({
  messageMedium,
  title = 'Next Best Action',
  ...props
}) => {
  const { toggleIsModalShown, reengagementModalExpandMode } = useNBAContext();
  const isModalOpen = reengagementModalExpandMode === ExpandModes.expand;
  const getPopoverContent = (
    <span>
      Next Best Action uses Iterable AI to look at your campaign performance and surface recommended
      steps to drive higher response.
      <StyledLearnMoreLinkWrapper>
        <NewTabLink
          href="https://support.iterable.com/hc/en-us/articles/25708106843028-Next-Best-Action-Overview"
          target="_blank"
          rel="noreferrer"
          data-test="nba-learn-more"
        >
          Learn More
        </NewTabLink>
      </StyledLearnMoreLinkWrapper>
    </span>
  );

  return (
    <StyledCampaignAnalyticsCard {...props} data-test="campaigns-nba-card-container">
      <CampaignNBACardHeader title={title} popoverContent={getPopoverContent} />
      <StyledDivider />
      <CampaignNBACardContent
        header="Retarget unengaged users with a new campaign"
        content={createPromptSubHeader(messageMedium)}
        onActionClick={toggleIsModalShown}
      />
      {isModalOpen && (
        <NBAReengagementModal
          isModalOpen={isModalOpen}
          messageMedium={messageMedium}
          onClose={toggleIsModalShown}
        />
      )}
    </StyledCampaignAnalyticsCard>
  );
};
